module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-238.bda5f0e1.svg";